import { useNavigate } from 'react-router-dom'

import { TimeoffPoliciesRemoveModalPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import Remove from 'modules/timeoff/components/TimeoffPolicies/Remove'

const RemoveModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useStrictParams<'id'>()
  const timeoffPolicyId = String(id)

  const onClose = () => {
    navigate(navigation.settings.timeoffPolicies.fullPath())
  }

  const { data, loading } = useQuery(TimeoffPoliciesRemoveModalPageDocument, {
    variables: {
      timeoffPolicyId,
    },
  })

  return <Remove loading={loading} data={data} onClose={onClose} />
}

export default RemoveModalPage
